'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _card = require('./card');

var _card2 = _interopRequireDefault(_card);

var _board = require('./board');

var _board2 = _interopRequireDefault(_board);

var _image = require('./image');

var _image2 = _interopRequireDefault(_image);

var _column = require('./column');

var _column2 = _interopRequireDefault(_column);

var _link = require('./link');

var _link2 = _interopRequireDefault(_link);

var _alias = require('./alias');

var _alias2 = _interopRequireDefault(_alias);

var _line = require('./line');

var _line2 = _interopRequireDefault(_line);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    (0, _card2.default)();
    (0, _image2.default)();
    (0, _link2.default)();
    (0, _column2.default)();
    (0, _board2.default)();
    (0, _alias2.default)();
    (0, _line2.default)();
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/initialiseElementTypes.js
// module id = 1986
// module chunks = 0